import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { assetKeys, discoveryKeys, tagKeys } from '@/shared/lib/query/queryKeys';

import { updateTagApi } from '@/features/tags/api';
import type { UpdateTagRequest } from '@/features/tags/api';

export const useUpdateTag = (tagFqn?: string) => {
  const queryClient = useQueryClient();
  const classification = tagFqn?.split('.')[0] || '';

  return useMutation({
    mutationFn: (request: UpdateTagRequest) => updateTagApi(request),
    onSuccess: () => {
      if (tagFqn) {
        queryClient.invalidateQueries({ queryKey: tagKeys.tagDetail(tagFqn) });
      }
      if (classification) {
        queryClient.invalidateQueries({ queryKey: tagKeys.tags(classification) });
        queryClient.invalidateQueries({ queryKey: tagKeys.categoryDetail(classification) });
        queryClient.invalidateQueries({ queryKey: tagKeys.tagsByCategory(classification) });
      }
      queryClient.invalidateQueries({ queryKey: tagKeys.categories() });
      queryClient.invalidateQueries({ queryKey: tagKeys.availableTags() });

      queryClient.invalidateQueries({ queryKey: assetKeys.assetBaseInfoPrefix() });
      queryClient.invalidateQueries({ queryKey: assetKeys.dataAssetsPrefix() });
      queryClient.invalidateQueries({ queryKey: assetKeys.schemaPrefix() });
      queryClient.invalidateQueries({ queryKey: discoveryKeys.searchPrefix() });
      queryClient.invalidateQueries({ queryKey: assetKeys.lineagePrefix() });

      queryClient.invalidateQueries({ queryKey: tagKeys.certificationAssetsPrefix() });
      queryClient.invalidateQueries({ queryKey: tagKeys.certificationAssetsCountPrefix() });

      notification.success({
        message: NOTIFICATION_MESSAGES.TAG_UPDATE_SUCCESS,
        description: NOTIFICATION_MESSAGES.TAG_UPDATE_SUCCESS_DESC,
        placement: 'bottomLeft',
        duration: 3,
      });
    },
  });
};
